var _rect, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarrelledWater(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70.4,
    height: 70.4,
    rx: 12,
    fill: "url(#paint0_linear_28_310)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8729 19C18.3723 19 17.9743 19.4201 18.0013 19.92L19.6527 50.4718C19.6778 50.9349 20.0606 51.2976 20.5244 51.2976H39.5698C38.074 49.7308 37.1555 47.6081 37.1555 45.271C37.1555 43.3671 37.765 41.6055 38.7996 40.1708C38.8166 40.1286 38.8373 40.0868 38.8618 40.0458L43.4137 32.4146L44.0891 19.92C44.1161 19.4201 43.718 19 43.2174 19H18.8729Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0969 21.643C21.7484 21.6673 21.5044 21.9707 21.5215 22.3196L22.7393 47.1418C22.7576 47.5137 23.0608 47.8059 23.4332 47.8059H35.6094C35.2621 46.89 35.0703 45.8845 35.0703 44.8294C35.0703 43.1799 35.5392 41.6513 36.3378 40.3975C36.3451 40.3812 36.3531 40.365 36.3618 40.3489L40.1758 33.2874L40.6143 24.915C40.6458 24.3133 39.9173 23.9107 39.3881 24.1988C37.5494 25.2001 34.0519 26.4741 30.7291 24.1879C26.9883 21.6141 23.4689 21.5471 22.0969 21.643Z",
    fill: "url(#paint1_linear_28_310)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6934 32.0722C48.0162 30.9369 46.3719 30.9369 45.6947 32.0722L40.5617 40.6775C40.5332 40.7252 40.5099 40.7741 40.4914 40.8234C39.4915 42.1934 38.9014 43.8815 38.9014 45.7074C38.9014 50.2873 42.6141 54 47.194 54C51.7739 54 55.4866 50.2873 55.4866 45.7074C55.4866 43.8815 54.8965 42.1935 53.8966 40.8236C53.8782 40.7741 53.8548 40.7253 53.8263 40.6775L48.6934 32.0722Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.806 42.5685V46.933H51.1705",
    stroke: "url(#paint2_linear_28_310)",
    strokeWidth: 1.74582,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_310",
    x1: 0,
    y1: 0,
    x2: 70.4,
    y2: 70.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0324701,
    stopColor: "#4DC1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#2AA5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0889FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28_310",
    x1: 30.1562,
    y1: 21.5184,
    x2: 30.1562,
    y2: 50.1538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32ABFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30A9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_28_310",
    x1: 48.9883,
    y1: 42.5685,
    x2: 48.9883,
    y2: 46.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#239FFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A98FE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarrelledWater);
export default __webpack_public_path__ + "static/media/barrelled-water.f1317a3c84ad3d8a7a5785bd3a4bd746.svg";
export { ForwardRef as ReactComponent };